module.exports = __webpack_public_path__ + "img/ic-excel-download.d4691ed1.svg";